import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import "./LandingStickyCta.css";

export default function LandingStickyCta() {
  return (
    <div className="landing-sticky-cta" aria-label="Быстрый старт">
      <div className="landing-sticky-cta__inner">
        <div className="landing-sticky-cta__text">
          <strong>14 дней бесплатно</strong>
          <span>Триал «Микрокоманда» без карты</span>
        </div>
        <Link to="/login?tab=register" className="landing-sticky-cta__link">
          <Button
            variant="contained"
            size="small"
            className="landing-sticky-cta__btn"
          >
            Начать триал
          </Button>
        </Link>
      </div>
    </div>
  );
}
